<template>
  <div class="comp-drag-drop-target"
    v-bind:class="dataId"
  >
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex  xs4 offset-xs2>
          <!-- <div class="ques-wrap ">
            <p v-bind:tabIndex="(enableTab) ? 1 : -1"
              v-focus="(initFocus && !hasAnswer)"
              @focus="initFocus = true"
              @blur="initFocus = false"
              class="title-style">
              {{content.data.title}}
            </p>
            <p v-bind:tabIndex="(enableTab) ? 2 : -1"
              class="desc-style">
              {{content.data.description}}
            </p>
          </div> -->
        </v-flex>
        <v-flex xs12 class="">
          <v-layout row wrap class="resp-wrap">
            <v-flex xs5 offset-xs2>
              <div class="ques-wrap ">
                <p v-bind:tabIndex="(enableTab) ? 1 : -1"
                  v-focus="(initFocus && !hasAnswer)"
                  @focus="initFocus = true"
                  @blur="initFocus = false"
                  class="title-style">
                  {{content.data.title}}
                </p>
                <p v-bind:tabIndex="(enableTab) ? 2 : -1"
                  class="desc-style">
                </p>
              </div>
              <div class="field-wrap">
                <div class="bubble">
                  <div class="field-parag"
                    v-for="(autofill, key) in content.data.fillables"
                    v-bind:key="key"
                    v-bind:dataKey="key"
                  >
                    <div class="text">{{autofill.field}}</div>
                    <div class="label">{{autofill.label}}</div>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs3>
              <div class="drop-wrap">
                <droppable-target class="droppables"
                  v-for="(dropTarget, key) in content.data.droppables"
                  v-bind:key="key"
                  v-bind:dataId="dataId"
                  v-bind:dataKey="key"
                  v-on:componentDrop="fillFields"
                >
                {{key}}
                </droppable-target>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="drag-wrap drag-wrap-shadow">
          <v-flex xs8 offset-xs2>
            <div class="instruction">{{content.data.description}}</div>
          </v-flex>
          <div class="drag-wrap center-content">
            <draggable-item class="draggables"
              v-for="(dragItems, key, index) in content.data.draggables"
              v-bind:key="key"
              v-bind:dataId="dataId"
              v-bind:dataKey="key"
              v-bind:tabbingIndex="(enableTab) ? (index + 2) : -1"
              v-show="index <= 5"
              v-on:componentDrop="fillFields"
            >
              </draggable-item>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <modal-ok
      :isShown="content.data.isComplete"
      @onClicked="nextStep"
    />
  </div>
</template>

<script>
import DraggableItem from '../../components/draggable-item/DraggableItem'
import DroppableTarget from '../../components/droppable-target/DroppableTarget'
import ModalOk from '../../components/modal-ok/modalOk'
import { focus } from 'vue-focus'
import { mapMutations } from 'vuex'

export default {
  name: 'DragDropTarget',
  data () {
    return {
      initFocus: false,
      enableTab: true,
      hasAnswer: false,
      answerCount: 0
    }
  },
  components: {
    DraggableItem,
    DroppableTarget,
    ModalOk
  },
  directives: {
    focus: focus
  },
  props: {
    dataId: {
      type: String,
      required: true
    },
    displayed: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      required: false,
      dafault: false
    }
  },
  watch: {
    isActive () {
      if (this.isActive) {
        this.initFocus = true
        this.activeTabIndex = 1
      } else {
        this.activeTabIndex = -1
      }
    }
  },
  created () {
  },
  computed: {
    content () {
      return this.$store.getters.getData(this.dataId)
    },
    draggables () {
      return this.content.data.draggables
    },
    fillables () {
      return this.content.data.fillables
    }
  },
  methods: {
    ...mapMutations([
      'nextSlide'
    ]),
    hideAllDragModal () {
      for (var key in this.content.data.draggables) {
        let dragObj = this.content.data.draggables[key]
        dragObj.hasDropList = false
      }
    },
    checkAnswer () {
      let acceptedKeys = this.droppable.accepted_keys
      let content = this.droppable.content

      if (acceptedKeys.length === content.length) {
        // this.droppable.completeAnswer = true
      }
      // this.checkAnswerCount()
    },
    fillFields (event) {
      let fieldKeys = this.draggables[event].fillableKeys
      let label = this.draggables[event].label

      for (let key in this.fillables) {
        this.fillables[key].field = '  '
      }

      for (let i = 0; i < fieldKeys.length; i++) {
        let key = fieldKeys[i]
        this.fillables[key].field = label
      }
    },
    checkAnswerCount () {
      let droppables = this.content.data.droppables
      for (var key in droppables) {
        let dropData = droppables[key]
        console.log(dropData)
        console.log(dropData.accepted_keys.length + '---' + dropData.content.length)
        if (dropData.accepted_keys.length === dropData.content.length) {
          dropData.completeAnswer = true
        }

        if (dropData.completeAnswer === false) {
          this.content.data.isComplete = false
          break
        } else {
          this.content.data.isComplete = true
        }
      }
      console.log(this.content.data.isComplete)
    },
    nextStep () {
      console.log(this.content.data.isComplete)
      if (this.content.data.isComplete) {
        this.nextSlide()
      } else {
        this.initFocus = true
        this.enableTab = true
        this.hasAnswer = false
        this.isCorrect = false
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/drag-drop-target/DragDropTarget.vue